import { types, actions } from './requests'
export const GETGT2000DATAFILTER_TYPES = {
    ...types('GETGT2000DATAFILTER'),
}
export const GETGT2000DATAFILTER_ACTIONS = {
    ...actions('GETGT2000DATAFILTER'),
}
